// GLOW-UP cart v4: progress bar + cross-sells. Refreshes on EVERY cart mutation (add/change/update),
// including the theme's own ajax, by hooking fetch + XHR. Tiers: SUMMER15 >= Rs.1499, MEGA20 >= Rs.5999.
// v4 fix: tier thresholds are evaluated on the PRE-DISCOUNT subtotal (original_total_price) — Shopify
// applies discount minimums to the pre-discount subtotal, so judging tiers on the discounted total made
// the bar contradict the applied code (and could re-apply the lower code) once a discount reduced the total.
(function () {
  var TIERS = [
    { min: 149900, code: 'SUMMER15' },
    { min: 599900, code: 'MEGA20' }
  ];
  var MAXAMT = 599900;
  var appliedCode = null;
  var isCartPage = window.location.pathname.indexOf('/cart') === 0;
  function inr(cents) { return '₹' + Math.ceil(cents / 100).toLocaleString('en-IN'); }

  function applyCode(code) {
    if (appliedCode === code) return;
    appliedCode = code;
    fetch('/discount/' + code).catch(function () {});
  }

  function renderProgress(total) {
    var el = document.querySelector('[data-gu-progress]');
    if (!el) return;
    var pct = Math.min(100, Math.round((total / MAXAMT) * 100));
    var msg;
    if (total >= TIERS[1].min) {
      msg = '20% off unlocked 🎉 code MEGA20 applied';
      applyCode('MEGA20');
    } else if (total >= TIERS[0].min) {
      msg = '15% off unlocked ✓ (SUMMER15) · add ' + inr(TIERS[1].min - total) + ' more for 20% off';
      applyCode('SUMMER15');
    } else if (total > 0) {
      msg = 'add ' + inr(TIERS[0].min - total) + ' more to unlock 15% off';
    } else {
      el.innerHTML = ''; return;
    }
    var m1 = Math.round((TIERS[0].min / MAXAMT) * 100);
    el.innerHTML = '<div class=\"gu-cp-msg\">' + msg + '</div>' +
      '<div class=\"gu-cp-track\">' +
      '<div class=\"gu-cp-fill\" style=\"width:' + pct + '%\"></div>' +
      '<div class=\"gu-cp-tick' + (total >= TIERS[0].min ? ' gu-cp-tick--hit' : '') + '\" style=\"left:' + m1 + '%\"><span>15%</span></div>' +
      '<div class=\"gu-cp-tick' + (total >= TIERS[1].min ? ' gu-cp-tick--hit' : '') + '\" style=\"left:100%\"><span>20%</span></div>' +
      '</div>';
  }

  function refreshDrawerItems() {
    if (isCartPage) { window.location.reload(); return; }
    fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var freshItems = doc.querySelector('.scd__items');
      var freshSub = doc.querySelector('[data-cart-subtotal-price]');
      var curBody = document.querySelector('.scd__wrapper:not(.sf-cart) .scd__body');
      if (curBody) {
        var curItems = curBody.querySelector('.scd__items');
        var empty = curBody.querySelector('.scd-empty-msg');
        if (freshItems) {
          if (curItems) { curItems.innerHTML = freshItems.innerHTML; }
          else if (empty) { empty.outerHTML = '<div class=\"scd__items\">' + freshItems.innerHTML + '</div>'; }
        }
      }
      var curSub = document.querySelector('.scd__wrapper:not(.sf-cart) [data-cart-subtotal-price]');
      if (curSub && freshSub) curSub.innerHTML = freshSub.innerHTML;
    });
  }

  function renderXsell(cartData) {
    var el = document.querySelector('[data-gu-xsell]');
    if (!el || el.dataset.guLoaded) return;
    el.dataset.guLoaded = '1';
    var inCart = cartData.items.map(function (i) { return i.product_id; });
    var seedId = cartData.items.length ? cartData.items[0].product_id : null;
    function draw(products) {
      products = products.filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available !== false; }).slice(0, 6);
      if (!products.length) { el.innerHTML = ''; return; }
      el.innerHTML = '<div class=\"gu-xs-title\">complete the fit</div><div class=\"gu-xs-row\">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.src ? p.featured_image.src : (p.images && p.images[0] ? (p.images[0].src || p.images[0]) : '');
        var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0];
        var price = v ? (typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price) : 0;
        return '<div class=\"gu-xs-card\">' +
          '<a href=\"/products/' + p.handle + '\"><img src=\"' + img + '\" alt=\"\"></a>' +
          '<div class=\"gu-xs-name\">' + p.title.toLowerCase() + '</div>' +
          '<div class=\"gu-xs-foot\"><span>' + inr(price) + '</span>' + (v ? '<button type=\"button\" class=\"gu-xs-add\" data-vid=\"' + v.id + '\">+ add</button>' : '') + '</div>' +
          '</div>';
      }).join('') + '</div>';
      el.querySelectorAll('.gu-xs-add').forEach(function (b) {
        b.addEventListener('click', function () {
          b.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(b.dataset.vid, 10), quantity: 1 }) })
            .then(function () { b.textContent = 'added ✓'; b.disabled = true; refreshDrawerItems(); })
            .catch(function () { b.textContent = '+ add'; });
        });
      });
    }
    if (seedId) {
      fetch('/recommendations/products.json?product_id=' + seedId + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d.products && d.products.length) { draw(d.products); } else { fallback(); } })
        .catch(fallback);
    } else { fallback(); }
    function fallback() {
      fetch('/collections/best-seller/products.json?limit=10').then(function (r) { return r.json(); }).then(function (d) { draw(d.products || []); }).catch(function () { el.innerHTML = ''; });
    }
  }

  var origFetch = window.fetch;
  function update() {
    origFetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var base = (typeof c.original_total_price === 'number') ? c.original_total_price : c.total_price;
      renderProgress(base);
      renderXsell(c);
    }).catch(function () {});
  }

  // hook every cart mutation, whoever makes it
  window.fetch = function () {
    var url = '';
    try { url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]); } catch (e) {}
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(update, 350); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
      this.addEventListener('loadend', function () { setTimeout(update, 350); });
    }
    return origOpen.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function () {
    update();
    var wrapper = document.querySelector('.scd__wrapper');
    if (wrapper) {
      new MutationObserver(function () { update(); }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    }
  });
})();
